export const checkNotSelectedCampaignIdAndSourceId = (id: string | null) => {
  if (id === '0' || id === '-1') {
    return true
  } else {
    return false
  }
}
